"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M8.4 7.2H7.2v6.87h7.179l-1.906 1.886.853.844 3.471-3.434-3.471-3.433-.853.844 2.117 2.094H8.4V7.2z" }), "Paragraph");
//# sourceMappingURL=Paragraph.js.map